/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateEquipmentWorkerRequest } from './update-equipment-worker-request';


export interface UpdateEquipmentRequest { 
    equipmentId: string;
    modeId?: number | null;
    workers: Array<UpdateEquipmentWorkerRequest>;
}

